<template>
  <ContentBlock>
    <div slot="instructions">
      <h5>{{ $t('Entertainment and Educational Locations') }}</h5>
      <i18n tag="p" path="SpringboardVR currently serves both educational institutions and location based entertainment facilities. To learn more about these two location types, read our post about {entertainmentEducationLink}.">
        <a slot="entertainmentEducationLink" href="https://support.springboardvr.com/hc/en-us/articles/360015797833-Entertainment-vs-Education" rel="noopener" target="_blank" class="link-style">{{ $t('Entertainment vs Education') }}</a>
      </i18n>
    </div>
    <div>
      <p class="f5">
        {{ $t('You can choose to offer your content to one or both location types.') }}
        <i18n
          v-if="localContentOwnership.status === 'active'"
          tag="span"
          path="Contact us at {supportEmail} if you want to stop distributing your content to a location type."
        >
          <a
            class="link-style"
            slot="supportEmail"
            href="mailto:support@springboardvr.com"
          >support@springboardvr.com</a>
        </i18n>
      </p>
      <div class="distribute">
        <UISwitch
          :title="$t('Distribute to Entertainment Locations')"
          :instructions="$t('Includes indie VR arcades, family entertainment centers, mobile VR units...')"
          v-model="localContentOwnership.distributeEntertainment"
          :disabled="localContentOwnership.status === 'active' && distributeEntertainmentLock"
        />
        <UISwitch
          :title="$t('Distribute to Educational Locations')"
          :instructions="$t('Includes universities, libraries, K-12 schools, museums, educational non-profits...')"
          v-model="localContentOwnership.distributeEducation"
          :disabled="localContentOwnership.status === 'active' && distributeEducationLock"
        />
      </div>
    </div>
  </ContentBlock>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import ContentBlock from '@/core/shared/components/ContentBlock';
import UISwitch from '@/core/shared/components/ui/UISwitch';

@Component({
  components: {
    ContentBlock,
    UISwitch,
  },
  props: {
    contentOwnership: { type: Object, required: true },
    distributeEntertainmentLock: { type: Boolean },
    distributeEducationLock: { type: Boolean },
  },
})
export default class Distribute extends Vue {
  get localContentOwnership () {
    return new Proxy(this.contentOwnership, {
      set: (object, property, value) => {
        this.$emit('edit:contentOwnership', property, value);
        return true;
      },
    });
  }
}
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

p.f5 {
  margin-bottom: var(--spacingMd);
}

.distribute {
  display: grid;
  grid-gap: var(--spacingMd);

  @media (--tablet) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
